import { render } from "./Num-header.vue?vue&type=template&id=1d78b403&scoped=true"
import script from "./Num-header.vue?vue&type=script&lang=js"
export * from "./Num-header.vue?vue&type=script&lang=js"

import "./Num-header.vue?vue&type=style&index=0&id=1d78b403&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d78b403"]])

export default __exports__